import { GetStreamBySlug_getStreamBySlug_overlayConfig_liveMatchState } from 'api/agora/types/GetStreamBySlug';
import { MatchupCorner } from 'api/graphql-global-types';
import { MatchupFields as Matchup } from 'api/matchup/types/MatchupFields';
import {
  formatRoundLabel,
  formatTimer,
  getCompetitorName,
  getCompetitorByCorner,
  getRoundDurationSeconds,
} from './fightCardHelpers';
import { ScoreboardOverlayProps } from './ScoreboardOverlay';

export type BuildScoreboardOverlayPropsArgs = {
  liveMatchState?: GetStreamBySlug_getStreamBySlug_overlayConfig_liveMatchState | null;
  matchups?: Matchup[] | null;
};

export const getScoreboardOverlayProps = ({
  liveMatchState,
  matchups,
}: BuildScoreboardOverlayPropsArgs): ScoreboardOverlayProps | null => {
  if (!liveMatchState || !liveMatchState.currentMatchupId) {
    return null;
  }

  const matchup = matchups?.find(
    (m) => m.id === liveMatchState.currentMatchupId
  );

  const fighterA =
    liveMatchState.fighterA ??
    (matchup
      ? getCompetitorName(getCompetitorByCorner(matchup, MatchupCorner.A))
      : null);
  const fighterB =
    liveMatchState.fighterB ??
    (matchup
      ? getCompetitorName(getCompetitorByCorner(matchup, MatchupCorner.B))
      : null);
  const totalRounds = liveMatchState.rounds ?? matchup?.rounds ?? null;
  const roundDurationSeconds =
    liveMatchState.roundDurationSeconds ?? getRoundDurationSeconds(matchup);

  return {
    fighterA,
    fighterB,
    weightClass: liveMatchState.weightClass ?? matchup?.category ?? null,
    roundLabel: formatRoundLabel(liveMatchState.currentRound, totalRounds),
    timer:
      typeof liveMatchState.roundTimerSeconds === 'number'
        ? formatTimer(roundDurationSeconds - liveMatchState.roundTimerSeconds)
        : null,
  };
};
